import { z } from "zod";

const raceCrewMemberSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  userId: z.string().optional(), // "other" or specific ID
});

export const raceRegistrationSchema = z.object({
  eventPricePointId: z.string().min(1, "Category is required"),
  boatClass: z.string().min(1, "Boat class is required"),
  sailNumber: z.string().min(1, "Sail number is required"),
  crew: z.array(raceCrewMemberSchema).min(1, "At least one crew member is required"),
});

export type RaceRegistrationFormData = z.infer<typeof raceRegistrationSchema>;
